<template>
  <div class="loadingSpinnerBar" >
        <div class="linear-progress">
            <div class="bar bar1"></div>
            <div class="bar bar2"></div>
        </div>
  </div>
</template>

<script>
export default {};
</script>
